'use client';
// imports
import { useEffect, useState, useCallback } from 'react';

// lib files
import { sendPbsGtmEvent } from '@/lib/helpers/send-pbs-gtm-event';
import { PASSPORT_ACTIVATION_FEATURE_CATEGORY } from '@/lib/constants';

// svgs
import CloseIcon from '@/public/svg/close.svg';
import PassportCompass from '@/public/svg/compass-rose.svg';

// styles
import styles from './MembershipSuccessPopup.module.scss';

interface MembershipSuccessPopupProps {
  shortCommonName: string;
}

const MembershipSuccessPopup = (props: MembershipSuccessPopupProps) => {
  const { shortCommonName } = props;
  const [isOpen, setIsOpen] = useState(true);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  useEffect(() => {
    sendPbsGtmEvent({
      feature_category: PASSPORT_ACTIVATION_FEATURE_CATEGORY,
      feature_name: 'passport membership success popup',
      object_name: 'popup',
      object_action: 'impression',
      object_action_behavior: 'display content',
    });

    // on load, remove the source=activation query param from the URL
    const url = new URL(window.location.href);
    url.searchParams.delete('source');
    window.history.replaceState({}, '', url.toString());

    document.addEventListener('click', handleClose);
    return () => {
      document.removeEventListener('click', handleClose);
    };
  }, [handleClose]);


  return (
    <div className={styles.membership_success_popup} hidden={!isOpen} role="status">
      <PassportCompass className={styles.passport_compass} />

      Success! You can now access {shortCommonName} Passport.

      <button
        className={styles.btn__close}
        onClick={handleClose}
        aria-label='Close'
      >
        <CloseIcon />
      </button>
    </div>
  );
};

export default MembershipSuccessPopup;
